<template>
  <div class="payment-row">
    <a-form :form="form" @submit="submitContract">
      <a-row :gutter="20">
        <a-col :span="4">
          <a-form-item class="travel-input-outer">
            <label class="filled">Valor total (R$) </label>
            <a-input
              class="travel-input"
              placeholder="Valor total"
              v-currency
              disabled
              v-decorator="[
                `package_total_price`,
                {
                  rules: [
                    {
                      required: true,
                      message: 'Obrigatório',
                    },
                  ],
                },
              ]"
              @blur="calcProfit(id)"
            >
              <a-icon slot="prefix" type="field-svg" />
            </a-input>
          </a-form-item>
        </a-col>

        <a-col :span="6">
          <a-form-item class="travel-input-outer travel-multiselector">
            <label :class="'filled'"> Fornecedor </label>
            <a-select
              class="travel-input"
              show-search
              :allow-clear="true"
              :disabled="!edit"
              optionFilterProp="txt"
              placeholder="Selecione "
              v-decorator="[
                `contract_finances_package_supplier_id`,
                {
                  rules: [
                    {
                      required: true,
                      message: 'Obrigatório',
                    },
                  ],
                },
              ]"
              style="width: 100%; height: 30px"
              @change="onSelectSupplier(id)"
            >
              <a-select-option
                v-for="(item, index) of productSupplier.list"
                :key="index"
                :value="item.id"
                :txt="item.trading_name"
              >
                {{ item.id }} -
                {{ item.trading_name.toUpperCase() }}
              </a-select-option>
            </a-select>
          </a-form-item></a-col
        >

        <a-col :span="4">
          <a-form-item class="travel-input-outer">
            <label :class="'filled'">Vencimento</label>
            <a-date-picker
              class="travel-input"
              placeholder="Selecione"
              :disabled="!edit"
              format="DD/MM/YYYY"
              :showToday="false"
              :allowClear="true"
              v-mask="'##/##/####'"
              v-decorator="[
                `contract_finances_package_expired_at`,
                {
                  rules: [
                    {
                      required: false,
                      message: 'Obrigatório',
                    },
                  ],
                },
              ]"
            >
              <a-icon slot="prefix" type="field-svg" />
            </a-date-picker>
          </a-form-item>
        </a-col>

        <a-col :span="4">
          <HayaSelectField
            label="Empresa"
            :fieldKey="`contract_finances_package_company_id`"
            :required="true"
            :form="form"
            :fieldClass="!edit ? 'readonly' : ''"
            :list="companiesList"
            @onChangeSelectField="getCompanyBranches"
          />

          <a-form-item class="readonl none">
            <a-input v-decorator="[`contract_finances_package_company`]" />
          </a-form-item>
        </a-col>

        <a-col :span="6">
          <HayaSelectField
            label="Filial"
            :fieldKey="`contract_finances_package_company_branch_id`"
            :required="false"
            :form="form"
            :fieldClass="!edit ? 'readonly' : ''"
            :list="companyBranchesList"
            @onChangeSelectField="setCompanyBranchName"
          />

          <a-form-item>
            <a-input
              class="readonly none"
              v-decorator="[`contract_finances_package_company_branch`]"
            />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="20">
        <a-col :span="4">
          <a-form-item class="travel-input-outer">
            <label class="filled">Valor a Pagar (R$) </label>
            <a-input
              class="travel-input"
              placeholder="Valor a Pagar "
              v-currencys
              :disabled="!edit"
              v-decorator="[
                `contract_finances_package_net_value`,
                {
                  rules: [
                    {
                      required: true,
                      message: 'Obrigatório',
                    },
                  ],
                },
              ]"
              @blur="calcProfit(id)"
            >
              <a-icon slot="prefix" type="field-svg" />
            </a-input>
          </a-form-item>
        </a-col>

        <a-col :span="5">
          <a-form-item class="travel-input-outer travel-multiselector">
            <label :class="'filled'"> Tipo de Pagamento </label>
            <a-select
              class="travel-input"
              show-search
              :allow-clear="true"
              @change="onChangePaymentType"
              :disabled="!edit"
              optionFilterProp="txt"
              placeholder="Selecione"
              v-decorator="[
                `contract_finances_package_payment_type`,
                {
                  rules: [
                    {
                      required: true,
                      message: 'Obrigatório',
                    },
                  ],
                },
              ]"
              style="width: 100%; height: 30px"
            >
              <a-select-option
                v-for="(item, index) of paymentType"
                :key="index"
                :value="item.name"
                :txt="item.name"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item></a-col
        >
        <a-col
          v-if="form.getFieldValue(`contract_finances_package_payment_type`)"
          :span="8"
        >
          <a-form-item class="travel-input-outer travel-multiselector">
            <label :class="'filled'"> Forma de Pagamento </label>
            <a-select
              class="travel-input"
              show-search
              :disabled="!edit"
              :allow-clear="true"
              optionFilterProp="txt"
              placeholder="Selecione"
              v-decorator="[
                `contract_finances_package_payment_method`,
                {
                  rules: [
                    {
                      required: true,
                      message: 'Obrigatório',
                    },
                  ],
                },
              ]"
              style="width: 100%; height: 30px"
            >
              <a-select-option
                v-for="(item, index) of paymentMethodsList"
                :key="index"
                :value="item.id"
                :txt="item.name"
              >
                <div
                  v-if="
                    form.getFieldValue(
                      `contract_finances_package_payment_type`
                    ) == 'Cartão de Crédito'
                  "
                >
                  {{ item.id }} - {{ item.card_name }} ({{ item.card_number }}
                  )
                </div>
                <div v-else>
                  {{ item.id }} - {{ item.company_name }} ({{ item.account }})
                </div>
              </a-select-option>
            </a-select>
          </a-form-item></a-col
        >

        <a-col :span="4">
          <a-form-item class="travel-input-outer">
            <label :class="'filled'">Dia do pagamento</label>
            <a-date-picker
              class="travel-input"
              :disabled="!edit"
              placeholder="Selecione"
              format="DD/MM/YYYY"
              :showToday="false"
              :allowClear="true"
              v-mask="'##/##/####'"
              v-decorator="[
                `contract_finances_package_payday`,
                {
                  rules: [
                    {
                      required: false,
                      message: 'Obrigatório',
                    },
                  ],
                },
              ]"
            >
              <a-icon slot="prefix" type="field-svg" />
            </a-date-picker>
          </a-form-item>
        </a-col>
        <a-col v-if="sale.status != 'Finalizado'" class="a-right" :span="3">
          <a-button
            v-if="edit"
            @click="editRow('cancel')"
            class="ml-10 cancel"
            type="primary"
          >
            <a-icon type="close" />
          </a-button>

          <a-button
            v-if="!edit"
            @click="editRow('edit')"
            class="ml-10 edit"
            type="primary"
          >
            <a-icon type="edit" />
          </a-button>

          <a-popconfirm
            placement="left"
            ok-text="Sim"
            cancel-text="Não"
            @confirm="confirmAuditory()"
          >
            <template slot="title">
              <p>
                Você confirma todos os valores e dados
                <br />inseridos neste recebimento? Após esta ação <br />
                não será mais possível editar.
              </p>
            </template>
            <a-button
              v-if="!edit"
              html-type="submit"
              class="ml-10 update"
              type="primary"
            >
              <a-icon type="check" />
            </a-button>
          </a-popconfirm>

          <a-button
            v-if="edit"
            html-type="submit"
            class="ml-10 save"
            type="primary"
            style="padding: 0px 6px"
          >
            <img src="@/assets/images/dashboard/sales/disket.png" alt="save" />
          </a-button>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import formatThings from "@/mixins/general/formatThings.js";
import productSupplierMixins from "@/mixins/product-suppliers/productSupplierMixins.js";
import HayaSelectField from "@/components/general/fields/HayaSelectField.vue";

export default {
  props: {
    tempContract: Object,
    sale: Object,
    id: Number,
  },
  components: { HayaSelectField },
  mixins: [formatThings, productSupplierMixins],
  data() {
    return {
      paymentType: [],
      companiesList: [],
      companyBranchesList: [],
      edit: false,
      paymentMethodsList: [],
      form: this.$form.createForm(this, {
        onValuesChange: this.updateTempContract,
      }),
    };
  },
  beforeMount() {
    this.$http.get(`/company/list?page=1&per_page=100`).then(({ data }) => {
      this.companiesList = data.data.map(({ id, trading_name }) => {
        return {
          label: `${id != 0 ? id + " - " : ""} ${trading_name} `,
          value: id,
          item: { trading_name, id },
        };
      });
    });
  },
  mounted() {
    this.productSupplier.pagination.perPage = 300;
    this.productSupplier.filters.only_specific_categories = 1;
    this.getProductSuppliers();

    let payments = JSON.parse(this.tempContract.payment_methods);

    this.$http
      .get(
        `/category-entry/list?page=1&per_page=10&category_id=15&order-by=name&order=ascend`
      )
      .then(({ data }) => {
        this.paymentType = data.data;
      });

    this.$http
      .get(
        `/company-bank-accounts/list?page=1&per_page=200&status=Ativo&allow_payments=1`
      )
      .then(({ data }) => {
        this.banksList = data.data;

        setTimeout(() => {
          if (payments.includes("bank-transfer")) {
            this.form.setFieldsValue({
              [`payment_methods_bank_transfer_bank`]:
                this.tempContract[`payment_methods_bank_transfer_bank`],
            });
          }
        }, 100);
      });

    if (payments.includes("bank-transfer")) {
      this.form.setFieldsValue({
        [`payment_methods_bank_transfer_total_value`]:
          this.tempContract[`payment_methods_bank_transfer_total_value`],
        [`payment_methods_bank_transfer_receipt_date`]:
          this.tempContract[`payment_methods_bank_transfer_receipt_date`],
      });
    }

    if (this.tempContract[`contract_finances_package_company_id`])
      this.getCompanyBranches(
        this.tempContract[`contract_finances_package_company_id`]
      );

    setTimeout(() => {
      this.form.setFieldsValue({
        [`package_total_price`]: this.tempContract[`package_total_price`],
        [`contract_finances_package_supplier_id`]:
          this.tempContract[`contract_finances_package_supplier_id`],
        [`contract_finances_package_expired_at`]:
          this.tempContract[`contract_finances_package_payday`],
        [`contract_finances_package_net_value`]:
          this.tempContract[`contract_finances_package_net_value`],
        [`contract_finances_package_payday`]:
          this.tempContract[`contract_finances_package_payday`],
        [`contract_finances_package_payment_type`]:
          this.tempContract[`contract_finances_package_payment_type`],
        [`contract_finances_package_company_id`]:
          this.tempContract[`contract_finances_package_company_id`],
        [`contract_finances_package_company_branch_id`]:
          this.tempContract[`contract_finances_package_company_branch_id`],
        [`contract_finances_package_company`]:
          this.tempContract[`contract_finances_package_company`],
        [`contract_finances_package_company_branch`]:
          this.tempContract[`contract_finances_package_company_branch`],
      });

      setTimeout(() => {
        this.form.setFieldsValue({
          [`contract_finances_package_payment_method`]:
            this.tempContract[`contract_finances_package_payment_method`],
        });
      }, 10);

      if (
        this.tempContract[`contract_finances_package_payment_method`] !=
        undefined
      ) {
        this.onChangePaymentType(
          this.tempContract[`contract_finances_package_payment_type`],
          true
        );
      }
    }, 500);
  },
  methods: {
    setCompanyBranchName(companyBranchId, obj) {
      companyBranchId;

      if (obj !== undefined)
        this.form.setFieldsValue({
          [`contract_finances_package_company_branch`]:
            obj.data.attrs.obj.item.name,
        });
    },
    getCompanyBranches(companyId, obj) {
      this.companyBranchesList = [];

      if (obj !== undefined)
        this.form.setFieldsValue({
          [`contract_finances_package_company`]:
            obj.data.attrs.obj.item.trading_name,
        });

      this.form.setFieldsValue({
        [`contract_finances_package_company_branch_id`]: undefined,
      });

      this.$http
        .get(
          `/company-branch/list?page=1&per_page=100&status=Ativo&show_in_contract=1&company_id=${companyId}`
        )
        .then(({ data }) => {
          this.companyBranchesList = data.data.map(({ id, name }) => {
            return {
              label: `${id != 0 ? id + " - " : ""} ${name} `,
              value: id,
              item: { name, id },
            };
          });
        })
        .catch(() => {
          this.$message.error("Nenhuma filial encontrada.");
        });
    },
    editRow(type) {
      if (type == "edit") {
        this.edit = true;
      }

      if (type == "cancel") {
        this.edit = false;
      }
    },
    onChangePaymentType(paymentType, onMount) {
      if (!onMount) {
        this.form.setFieldsValue({
          [`contract_finances_package_payment_method`]: undefined,
        });
      }

      if (
        paymentType == "Boleto Bancário" ||
        paymentType == "Faturado" ||
        paymentType == "Transferência Bancária"
      ) {
        this.$http
          .get(`/company-bank-accounts/list?page=1&per_page=200&status=Ativo`)
          .then(({ data }) => {
            this.paymentMethodsList = data.data;
          });
      }

      if (paymentType == "Cartão de Crédito") {
        this.$http
          .get(`/company-credit-card/list?page=1&per_page=100&status=Ativo`)
          .then(({ data }) => {
            this.paymentMethodsList = data.data;
          });
      }
    },
    confirmAuditory() {
      let values = {};
      values[`contract_finances_package_audit_status`] = "Realizado";
      values[`contract_finances_package_audit_user_id`] =
        this.$store.state.userData.id;
      values.id = this.tempContract.id;
      values.sale_id = this.sale.id;
      values.module = "sale";
      values.action = "update-contract-package-status-in-sale";
      values.modified_by = {
        name: `${this.$store.state.userData.first_name} ${this.$store.state.userData.last_name}`,
        id: this.$store.state.userData.id,
      };

      this.$http
        .post("/contract/update-multi-meta", values)
        .then(({ data }) => {
          this.$message.success(data.message);
          this.$emit("updateTempContract", this.tempContract);
          this.edit = false;
        })
        .catch(({ response }) => {
          this.$message.error(response.data.message);
        });
    },
    submitContract(e) {
      e.preventDefault();

      this.form.validateFields((err, values) => {
        values.id = this.tempContract.id;
        values.sale_id = this.sale.id;
        values.module = "sale";
        values.action = "update-contract-package-in-sale";
        values.modified_by = {
          name: `${this.$store.state.userData.first_name} ${this.$store.state.userData.last_name}`,
          id: this.$store.state.userData.id,
        };

        if (!err) {
          this.$http
            .post("/contract/update-multi-meta", values)
            .then(({ data }) => {
              this.$message.success(data.message);
              this.$emit("updateTempContract", this.tempContract);
              this.edit = false;
            })
            .catch(({ response }) => {
              this.$message.error(response.data.message);
            });
        } else {
          this.$message.error("Prrencha todos os campos.");
        }
      });
    },
  },
};
</script>

<style lang="sass" scoped>
.content
  padding: 20px 20px 0
  .edit
    background: #f27935
    border-color: #f27935
    padding: 5px 10px
  .cancel
    background: #59595b
    border-color: #59595b
    padding: 5px 10px
  .update
    background: #2ecc71
    border-color: #2ecc71
    padding: 5px 10px
  .save
    background: #00acec
    border-color: #00acec
    padding: 0 6px
</style>
